import styled, { css } from 'styled-components';
import { FaCheck } from 'react-icons/fa';
import Tooltip from 'components/Tooltip';
import { variants, th } from 'style/theme';

export const StyledTextArea = styled.textarea`
  width: 100%;
  font-size: 15px;
  padding: 8px;
  border-radius: 5px;
  font-family: inherit;
  font-size: inherit;
  min-height: ${({ minHeight }) => `${minHeight}px`};
  margin-top: 4px;
`;

export const CharCount = styled.div`
  text-align: ${({ textAlign }) => textAlign};
  font-size: 12px;
  opacity: 0.5;
  margin-right: 3px;
  ${variants('variant', {
    rh: css`
      color: ${th('colors.blueGray2')};
      opacity: 1;
    `
  })}
`;

export const Optional = styled.span`
  font-weight: 400;
  font-size: 14px;
  margin-left: 4px;
`;

export const ErrorMessage = styled.span`
  margin-left: 5px;
  color: ${th('colors.red')};
  font-weight: 700;
  font-size: 14px;
`;

export const CheckIcon = styled(FaCheck)`
  margin-left: 7px;
  font-size: 14px;
  color: ${th('colors.bermudaGreen')};
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: 8px;
`;

export const Comment = styled.div`
  font-weight: normal;
  font-size: 15px;
`;
